export default [
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
];



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Typography/TypographyTypes.jsx